<template>
    <svg
        class="fill-current"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M19 26L19 13L8 13L8 26H6L6 13C6 11.8954 6.89543 11 8 11L19 11C20.1046 11 21 11.8954 21 13L21 26H19Z"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M24 26L24 8L12 8V8.94718H10V8C10 6.89543 10.8954 6 12 6L24 6C25.1046 6 26 6.89543 26 8L26 26H24Z"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.5 22H14.3709V20H10.5V22Z"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.5 16H16.5V18H10.5V16Z"
        />
    </svg>
</template>
